<template>
  <component
    :is="component"
    :class="[`align-${align}`]"
    class="button-block-icon-arrow"
    :to="to"
  >
    <div class="icon-wrapper"><slot name="icon" /></div>
    <div class="details">
      <slot />
    </div>
    <div class="arrow">
      <icon class="graphic arrow-off" name="nextSmall" />
      <icon class="graphic arrow-on" name="nextSmall" />
    </div>
  </component>
</template>
<script setup lang="ts">
import type { NuxtLinkProps } from '#app';

import type { RouteLocationRaw } from 'vue-router';

interface Props extends NuxtLinkProps {
  to?: RouteLocationRaw;
  align?: 'left' | 'center';
}

const props = defineProps({
  to: null,
  align: { default: 'left' }
});

const component = computed(() => {
  if (props.to) {
    return resolveComponent('NuxtLink');
  }
  return 'button';
});
</script>
<style lang="scss" scoped>
.icon-wrapper {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  :deep(.icon),
  :deep(img) {
    transition: opacity 250ms $ease-in-quad, transform 450ms $ease-out-circ;
  }
}

.arrow {
  position: relative;
  align-self: center;
  width: 2.4rem;
  height: 2.4rem;
  color: var(--color_secondary);
  .graphic {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(0) scale(1);
    transition: transform 400ms $ease-out-back 200ms,
      opacity 50ms $ease-in-quad 200ms;
    opacity: 1;
  }
  .arrow-on {
    transform: translateX(-1.4rem) scale(0.8);
    transition: transform 400ms $ease-in-quad;
    opacity: 0;
  }
}

.details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  text-align: left;
}

.button-block-icon-arrow {
  display: grid;
  grid-template-columns: minmax(5rem, auto) 1fr 2rem;
  width: 100%;
  min-height: 7.4rem;
  padding: var(--gap_m);
  border-color: var(--color_secondary_lighter);
  color: var(--color_neutral_900);
  gap: var(--gap_m);

  @include stroke('m', 'm');
  @include font('n', 400, 'secondary');
  &:hover,
  &:focus {
    .arrow-on {
      transform: translateX(0) scale(1);
      transition: transform 350ms $ease-out-back 200ms,
        opacity 80ms $ease-in-circ 200ms;
      opacity: 1;
    }
    .arrow-off {
      transform: translateX(1.8rem) scale(0.6);
      transition: transform 250ms $ease-in-back,
        opacity 100ms $ease-out-quad 160ms;
      opacity: 0;
    }
    .icon-wrapper {
      :deep(.icon),
      :deep(img) {
        transform: translate(-0.1rem, -0.1rem) scale(1.1);
        transition: opacity 250ms $ease-in-quad,
          transform 450ms $ease-out-back-custom;
      }
    }
  }
}
</style>
